import styled from 'styled-components';

import { token } from '@zillow/constellation';
import { Container } from '@zillow/zrs-comet';

export const StyledContainer = styled(Container)`
    border: 1px solid ${token('colors.gray300')};
    border-radius: 5px;
`;
